import healthLoader from '@legit-health/svg-images/images/health-loader.svg';
import logo from '@legit-health/svg-images/images/legit-health-logo.svg';
import {ResponsiveImage} from '@legit-health/ui';
import {styled} from '@mui/material/styles';

const DivContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100vh',
  backgroundColor: 'white'
}));

const DivWrapper = styled('div')(() => ({
  width: '150px'
}));

const LogoImage = styled('img')(({theme}) => ({
  display: 'block',
  width: '150px',
  height: 'auto',
  marginTop: theme.spacing(4)
}));

export default function AppLoading() {
  return (
    <DivContainer>
      <DivWrapper>
        <ResponsiveImage src={healthLoader} alt="Loading" />
        <LogoImage src={logo} alt="Legit.Health" />
      </DivWrapper>
    </DivContainer>
  );
}
